import React, { useEffect, useState } from 'react';

const EMOJIS = ['⭐', '🎉', '🌟', '✨', '🎊', '💫'];

const CelebrationOverlay = ({ stars }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      emoji: EMOJIS?.[Math.floor(Math.random() * EMOJIS?.length)],
      left: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 1}s`,
      animationDuration: `${1.5 + Math.random() * 1}s`,
      fontSize: `${1 + Math.random() * 1.5}rem`,
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="fixed inset-0 z-50 pointer-events-none flex items-center justify-center">
      {/* Particles */}
      {particles?.map(p => (
        <div
          key={p?.id}
          className="absolute top-0 animate-bounce"
          style={{
            left: p?.left,
            animationDelay: p?.animationDelay,
            animationDuration: p?.animationDuration,
            fontSize: p?.fontSize,
          }}
        >
          {p?.emoji}
        </div>
      ))}
      {/* Center message */}
      <div className="bg-white rounded-3xl shadow-2xl p-8 text-center mx-4 animate-pulse">
        <div className="text-6xl mb-3">🎉</div>
        <h2 className="text-2xl font-bold text-foreground mb-1">Reward Requested!</h2>
        <p className="text-muted-foreground text-sm">Your teacher will approve it soon</p>
        <div className="flex items-center justify-center space-x-1 mt-3">
          <span className="text-2xl">⭐</span>
          <span className="text-xl font-bold text-amber-600">{stars} stars spent</span>
        </div>
      </div>
    </div>
  );
};

export default CelebrationOverlay;
